import React, { Component } from 'react';
import Grid from '../../Utils/GridFiltro';
import PropTypes from 'prop-types';
import { standardActions } from '../../Utils/GridFiltro/StandardActions';
import moment from 'moment';
import NavbarModulo from '../../components/NavbarModulo';
import NavbarModuloLF from '../../components/NavbarModuloFage';
const valEmp = __CONFIG__.empresa;

class AltaList extends Component{
    static propTypes = {
        data: PropTypes.object.isRequired,
        loader: PropTypes.bool.isRequired,
    };

    static defaultProps = {
        loading: true
    };

    componentDidMount = () => {
        const { listar, getModulo } = this.props;
        let ruta = window.location.href;
        let modulo = ruta.split('/');
        listar();
        if (valEmp === 'fage'){
            getModulo(modulo[6],modulo[5]);
        }else{
            getModulo(modulo[5],modulo[4]);
        }
    }
    render(){
        const { data, loader, eliminar, modulo } = this.props;
        let ruta = window.location.href;
        let id_emp = ruta.split('/');
        return(
            <React.Fragment>
                {valEmp === 'fage' &&
                    <NavbarModuloLF
                        modulo={modulo}
                    />
                }
                {valEmp === '' &&
                    <NavbarModulo
                        modulo={modulo}
                    />
                }
                <br />
                <h3 className="p-2 bg-secondary title">Alta de igss</h3>
                <br />
                {valEmp === 'fage' &&
                    <div className="d-flex flex-row justify-content-start mb-2">
                        <a
                            href={`/#/lfg/rr_hh/${id_emp[6]}/alta_igss/crear`}
                            className='btn btn-primary'
                        >
                            Crear alta
                        </a>
                    </div>
                }
                {valEmp === '' &&
                    <div className="d-flex flex-row justify-content-start mb-2">
                    <a
                            href={`/#/rr_hh/${id_emp[5]}/alta_igss/crear`}
                            className='btn btn-primary'
                        >
                            Crear alta
                        </a>
                    </div>
                }
                {data &&
                    <Grid 
                        hover 
                        striped 
                        data={data}
                        loading={loader} 
                        headerStyle={ { background: 'black' } } 
                        //onPageChange={onPageChange}
                        //onSortChange={onSortChange} 
                    >
                        <TableHeaderColumn
                            isKey
                            dataField="codigo"
                            dataAlign='left'
                            width="150"
                            dataSort
                            thStyle={
                                {color: 'white'}}
                            tdStyle={
                                {color: 'white'}}
                        >
                            Codigo
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            dataField="nombre"
                            dataAlign='left'
                            dataSort
                            thStyle={
                                {color: 'white'}}
                            tdStyle={
                                {color: 'white'}}
                        >
                            Nombre
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            headerAlign="center"
                            dataAlign="right"
                            dataField="fecha_suspension"
                            width="200"
                            dataSort
                            dataFormat={(cell, row)=>{
                                return moment(cell).format("DD/MM/YYYY");
                            }}
                            thStyle={
                                {color: 'white'}}
                            tdStyle={
                                {color: 'white'}}
                        >
                            Fecha suspensión
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            headerAlign="center"
                            dataAlign="right"
                            dataField="fecha_alta"
                            width="200"
                            dataSort
                            dataFormat={(cell, row)=>{
                                return moment(cell).format("DD/MM/YYYY");
                            }}
                            thStyle={
                                {color: 'white'}}
                            tdStyle={
                                {color: 'white'}}
                        >
                            Fecha alta
                        </TableHeaderColumn>
                        {valEmp === 'fage' &&
                            <TableHeaderColumn
                                thStyle={
                                {color: 'white'}}
                                dataField="id"
                                width="150"
                                dataAlign="center"
                                dataSort
                                dataFormat={standardActions({ 
                                    editar_alta_igss_lfg: "alta_igss", 
                                    ver: "alta_igss",
                                    eliminarAltaIgss: eliminar,
                                    modulo: id_emp[5],
                                    empresa: id_emp[6],
                                    periodo: id_emp[8],
                                })} 
                                
                            >
                                Acciones
                            </TableHeaderColumn>
                        }
                        {valEmp === '' &&
                            <TableHeaderColumn
                                thStyle={
                                {color: 'white'}}
                                dataField="id"
                                width="150"
                                dataAlign="center"
                                dataSort
                                dataFormat={standardActions({ 
                                    editar_alta_igss: "alta_igss", 
                                    ver: "alta_igss",
                                    eliminarAltaIgss: eliminar,
                                    modulo: id_emp[4],
                                    empresa: id_emp[5],
                                    periodo: id_emp[7],
                                })} 
                                
                            >
                                Acciones
                            </TableHeaderColumn>
                        }
                    </Grid>
                }
            </React.Fragment>
        );
    }
}

export default AltaList;
